/* eslint-disable */
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Info from '@/Components/InfoTab/Info';
import { urls } from '@/Constants';
import GrnHeader from '@/Pages/GRNPage/grnHeader';
import Tab from '@/Components/InfoTab/tab';
import WastageTable from './wastageTable';
import wastageAnalyticsServices from '@/Services/Analytics Services/wastage-analytics.services';
import useKeyPress from '@/Helpers/useKeyPress';
import {
	inputHelper, keyPressHandler, useProductData,
	useQuery,
	variantMap
} from '@/Helpers';

const tabList = [
	{
		label: 'Dispatched Items',
		value: 'dispatchedItems',
	},
	{
		label: 'Received Items',
		value: 'receivedItems',
	},
];

const fieldsMap = {
	'Vehicle Number': 'vehicleNumber',
	'Dispatched From': 'dispatchedFrom',
	'Received At': 'receivedAt',
	'Current Status': 'currentStatus',
	'Dispatch Date': 'dispatchDate',
	'Receiving Date': 'receivingDate',
};

const dispatchSpecialColoumn = [
	{
		title: 'Product Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sku Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Quantity',
		config: {
			type: 'DATA',
		},
	},
];

const dispatchColMap = {
	'Product Name': 'name',
	Unit: 'unit',
	Quantity: 'qty',
	Category: 'category',
	'Sub Category': 'subCategory',
	'Sku Code': 'skuCode',
};

const receiveSpecialColoumn = [
	{
		title: 'Product Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sku Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Quantity',
		config: {
			type: 'DATA',
		},
	},

];

const receiveColMap = {
	'Product Name': 'name',
	Unit: 'unit',
	Quantity: 'qty',
	Category: 'category',
	'Sub Category': 'subCategory',
	'Sku Code': 'skuCode',
};

function TransitDetails() {
	const query = useQuery();
	const dateRange = query?.get('dateRange');
	const [transitInfo, setTransitInfo] = useState({});
	const location = useLocation();
	const { data: transitData, idx } = location?.state;
	const [dispatchedItems, setDispatchedItems] = useState([]);
	const [receivedItems, setReceivedItems] = useState([]);
	const [tabValue, setTabValue] = useState('');
	const transitList = useSelector((state) => state?.wastage?.transitList);
	const backUrl = `${urls.EXTENSION}${urls.WASTAGE_TRANSIT_LOGS}?dateRange=${dateRange}`;
	const history = useHistory();
	const keyPressed = useKeyPress();
	const dispatch = useDispatch();
	const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);
	const variant = variantMap(products);
	useEffect(() => {
		// if (Array.isArray(products) && products?.length === 0) {
		useProductData(dispatch);
		// }
	}, []);

	useEffect(() => {
		setTabValue('dispatchedItems');
	}, [transitData]);

	const handleFetchItems = async () => {
		try {
			const response = await wastageAnalyticsServices?.transitDetails({
				data: {
					dispatchId: transitData?.dispatchId,
					receiveId: transitData?.receivingId,
				},
			});
			if (response?.statusCode === 200) {
				setDispatchedItems(response?.data?.dispatchedItems?.map((item) => ({
					...item,
					name: `${item?.productName} (${item?.variantName})`,
					category: variant?.[item?.variantId]?.categoryName,
					subCategory: variant?.[item?.variantId]?.subCategoryName,
					skuCode: variant?.[item?.variantId]?.clientVariantId,
				})));
				setReceivedItems(response?.data?.receivedItems?.map((item) => ({
					...item,
					name: `${item?.productName} (${item?.variantName})`,
					category: variant?.[item?.variantId]?.categoryName,
					subCategory: variant?.[item?.variantId]?.subCategoryName,
					skuCode: variant?.[item?.variantId]?.clientVariantId,
				})));
			}
		} catch (error) {
			console.log(error);
		}
	};
	useEffect(() => {
		handleFetchItems();
	}, [transitData]);

	const handleTabChange = (value) => {
		setTabValue(value);
	};

	useEffect(() => {
		setTransitInfo({
			vehicleNumber: transitData?.vehicleNumber ?? 'N/A',
			dispatchedFrom: transitData?.dispatchStore ?? 'N/A',
			receivedAt: transitData?.receivingStore ?? 'N/A',
			currentStatus: transitData?.status ?? 'N/A',
			dispatchDate: moment(transitData?.dispatchDate).format('DD-MM-YYYY') ?? 'N/A',
			receivingDate: moment(transitData?.receivingDate).format('DD-MM-YYYY') ?? 'N/A',
		});
	}, [transitData]);

	const dispatchSpecialItems = {
		'Product Name': (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		Category: (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		'Sub Category': (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		'Sku Code': (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		Unit: (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		Quantity: (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
	};

	const receiveSpecialItems = {
		'Product Name': (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		Category: (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		'Sub Category': (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		'Sku Code': (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		Unit: (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
		Quantity: (_, item) => <p className='text-[12px] text-nowrap text-left'>{item}</p>,
	};

	const navigateQc = (e) => {
		const { dataset } = inputHelper(e);
		let newListItem = null;
		let newIdx = null;

		if (dataset.type === 'next') {
			newListItem = transitList?.[idx + 1];
			newIdx = idx + 1;
		} else {
			newListItem = transitList?.[idx - 1];
			newIdx = idx - 1;
		}

		if (newListItem) {
			history.push({
				pathname: `${urls.EXTENSION}${urls.TRANSIT_LOG_DETAILS}`,
				search: `?dateRange=${dateRange}`,
				state: {
					data: newListItem,
					idx: newIdx,
				},
			});
		}
	};

	useEffect(() => {
		const qcData = transitList?.[idx] ?? null;
		if (
			(keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight') &&
			qcData !== null
		) {
			const result = keyPressHandler(
				keyPressed,
				transitList,
				idx
			);

			if (result) {
				let newIdx;
				if (keyPressed === 'ArrowRight') {
					newIdx = idx + 1;
				} else {
					newIdx = idx - 1;
				}

				history.push({
					pathname: `${urls.EXTENSION}${urls.TRANSIT_LOG_DETAILS}`,
					search: `?dateRange=${dateRange}`,
					state: {
						data: result,
						idx: newIdx,
					},
				});
			}
		}
	}, [keyPressed]);

	return (
		<>
			<GrnHeader
				title='Back to Transit Logs'
				navigateLabel=''
				url={backUrl}
				id={transitData?.dispatchId}
				navigatePrevToolTip='Prev Transit'
				navigateNextToolTip='Next Transit'
				navigateQC={navigateQc}
				listData={transitList}
				idx={idx}
			/>
			<div className='relative top-[3rem]'>
				<Info
					fieldMap={fieldsMap}
					data={transitInfo}
					heading={
						{
							value: `Return wastage in Vehicle No. ${transitData?.vehicleNumber}`,
						}
					}
				/>
				<Tab
					tabList={tabList}
					tabValue={tabValue}
					handleTabChange={handleTabChange}
				/>
				{tabValue === 'dispatchedItems' && (
					<WastageTable
						special={dispatchSpecialColoumn}
						colMap={dispatchColMap}
						specialMappings={dispatchSpecialItems}
						data={dispatchedItems}
						tableType='dispatchedItems'
					/>
				)}
				{tabValue === 'receivedItems' && (
					<WastageTable
						special={receiveSpecialColoumn}
						colMap={receiveColMap}
						specialMappings={receiveSpecialItems}
						data={receivedItems}
						tableType='receivedItems'
					/>
				)}
			</div>
		</>
	);
}
export default TransitDetails;
